import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { PageComponent } from '@shared/components';
import { ContentPageId } from '@shared/models';
import { OpenChoiceCommonContent } from '@shared/services/content/content-jsons/open-choice/open-choice-common.content';
import { TaxFilingRetirementContent } from '@shared/services/content/content-jsons/open-choice/tax-filing-retirement.content';
import * as fromRootStore from '@store/index';
import { selectClientDateOfBirth } from '@store/selectors/personal-data/personal-data.selectors';
import { combineLatest, Observable, take } from 'rxjs';
import {
  selectEmploymentStatusState,
  selectRetirementAge,
  selectTaxableIncome,
  selectTaxStatus,
  TaxableIncome,
} from 'vg-interaction-model/dist';
import { IEmploymentStatusAndDetailsState } from 'vg-interaction-model/dist/lib/features/employment/store/reducers/employment-status/employment-status.reducer';

@Component({
  selector: 'app-tax-filing-retirement',
  templateUrl: './tax-filing-retirement.component.html',
  styleUrl: './tax-filing-retirement.component.scss',
})
export class TaxFilingRetirementComponent extends PageComponent implements OnInit, OnDestroy {
  content = TaxFilingRetirementContent;
  openChoiceCommonContent = OpenChoiceCommonContent;
  retirementAge$: Observable<number | null>;
  birthDate$: Observable<string | null>;
  employmentStatusState$: Observable<IEmploymentStatusAndDetailsState>;
  taxStatus$: Observable<string>;
  taxableIncome$: Observable<TaxableIncome>;

  shouldTaxesErrorShow = false;
  shouldTaxableIncomeErrorShow = false;
  shouldRetirementAgeErrorShow = false;
  shouldContinueButtonSpinnerShow = false;
  employmentStatus: string | undefined;

  constructor(globalStore: Store<fromRootStore.State>) {
    super(ContentPageId.taxFilingRetirement, globalStore);

    this.retirementAge$ = this.globalStore.pipe(select(selectRetirementAge));
    this.birthDate$ = this.globalStore.pipe(select(selectClientDateOfBirth));
    this.employmentStatusState$ = this.globalStore.pipe(select(selectEmploymentStatusState));
    this.taxStatus$ = this.globalStore.pipe(select(selectTaxStatus));
    this.taxableIncome$ = this.globalStore.pipe(select(selectTaxableIncome));
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.subs.add(
      this.employmentStatusState$.subscribe(
        (employmentStatusState) => (this.employmentStatus = employmentStatusState.employmentStatus),
      ),
    );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  continue() {
    this.shouldRetirementAgeErrorShow = true;
    this.shouldTaxesErrorShow = true;
    this.shouldTaxableIncomeErrorShow = true;

    combineLatest([this.retirementAge$, this.taxStatus$, this.taxableIncome$])
      .pipe(take(1))
      .subscribe(
        ([retirementAge, taxStatus, taxableIncome]: [number | null, string, TaxableIncome]) => {
          const isFormValid = retirementAge && taxStatus && taxableIncome;

          if (isFormValid) {
            this.globalStore.dispatch(fromRootStore.initializeOnboarding());
          }
        },
      );
  }
}
